<div class="table scroll"
     [class.is-material]="isMaterial"
     [class.no-background]="rowExpand">
    <app-table-header [ngClass]="{'show-filters': showFilters}"
                      [columns]="columns"
                      [config]="config"
                      [hasTitle]="hasTitle"
                      [title]="title"
                      [rowExpand]="rowExpand"
                      [allExpanded]="allExpanded"
                      [filtersToggle]="filtersToggle"
                      [showFilters]="showFilters"
                      [showGroupFilters]="showGroupFilters"
                      [groupFilters]="groupFilters"
                      [showGroupers]="showGroupers"
                      [groupableColumns]="groupableColumns"
                      [directlyGrouped]="directlyGrouped"
                      [hasToggleFilters]="displayToggleFilters"
                      [displayToolsUsageLegend]="displayToolsUsageLegend"
                      [saveFilters]="saveFilters"
                      [backgroundColor]="headerBackgroundColor"
                      [parentComponent]="parentComponent"
                      [isFilterExpanded]="isFilterExpanded"
                      [childTemplate]="childTemplate"
                      [definedGroupers]="definedGroupers"
                      [hasSelectALl]="hasSelectAll"
                      [isSelectAllChecked]="isSelectAllChecked"
                      (expandAll)="onExpandAll($event)"
                      (sort)="onSortChange($event)"
                      (filter)="onFilterChange($event)"
                      (filterToggled)="onFilterToggled($event)"
                      (groupFilter)="onFilterGroupChanged($event)"
                      (onFilterToggle)="onFilterToggle($event)"
                      (lineIdFilter)="onFilteredByLine($event)"
                      (selectAll)="onSelectAll()"
                      (unSelectAll)="onUnselectAll()"
                      (group)="onGroupChange($event)">
    </app-table-header>
    <app-table-body [ngClass]="{'show-filters': showFilters}"
                    [records]="data"
                    [isLoading]="isLoading"
                    [columns]="columns"
                    [infoRow]="infoRow"
                    [rowExpand]="rowExpand"
                    [filteredByLineId]="filteredByLine"
                    [hasActiveGroups]="groupableColumns.length > 0"
                    [contextMenuItems]="contextMenuItems"
                    [includeSecondaryLines]="includeSecondaryLines"
                    [filterBySecLinesId]="filterBySecLinesId"
                    [notMyProblem]="notMyProblem"
                    (rowExpandClick)="onRowExpandClick($event)"
                    (rowClick)="onRowClick($event)"
                    (rowContextMenu)="onRightRowClick($event)">
    </app-table-body>
    <app-table-footer *ngIf="hasFooter"
                      [selectableRows]="selectableRows"
                      [hasPagination]="hasPagination"
                      [config]="config"
                      (pageChange)="onPageChange($event)">
    </app-table-footer>
</div>

<p-contextMenu
    *ngIf="rowDuplicate || rowNewPage || contextMenuItemsFactory"
    appendTo="body"
    [style]="{backgroundColor:'white', color: 'black'}"
    [model]="contextMenuItems">
</p-contextMenu>

